import { useTranslation } from "react-i18next";
import { Label, Input } from "@tellescope/ui";
import type { WeightMacroTrackerBlock } from "../../../../../shared/schema";
import { LayoutSection } from "../shared/LayoutSection";
import { VisibilitySection } from "../shared/VisibilitySection";
import type { BlockTypeEditorProps } from "../types";

type WeightMacroTrackerBlockEditorProps = BlockTypeEditorProps<WeightMacroTrackerBlock>;

export const WeightMacroTrackerBlockEditor = ({
  block,
  updateProps,
  updateLayout,
  updateVisibility,
  layoutOpen,
  setLayoutOpen,
  visibilityOpen,
  setVisibilityOpen,
}: WeightMacroTrackerBlockEditorProps) => {
  const { t } = useTranslation("portal");

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label>{t("Empty Message (optional)")}</Label>
        <Input
          value={block.props.emptyMessage || ""}
          onChange={(e) => updateProps({ emptyMessage: e.target.value || undefined })}
          placeholder={t("Failed to load nutrition data")}
        />
      </div>

      <LayoutSection layout={block.layout} onChange={updateLayout} open={layoutOpen} onOpenChange={setLayoutOpen} />
      <VisibilitySection
        visibility={block.visibility}
        onChange={updateVisibility}
        open={visibilityOpen}
        onOpenChange={setVisibilityOpen}
      />
    </div>
  );
};
